import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <footer className="bg-white pt-16 pb-8 border-t-2 border-kitty-yellow" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-44">
          <div className="col-span-1 md:col-span-2" data-id="element-45">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-46">
              <img src="https://cdn.magicpatterns.com/uploads/ftH2pUqynHNmgSwuNa6Kz8/LOGO_-_5000px.png" alt="KittyPot logo" className="w-9 h-9 object-contain rounded-full" data-id="element-47" />
              <span className="font-bold text-xl tracking-tight text-kitty-dark" data-id="element-48">
                KittyPot
              </span>
            </Link>
            <p className="text-gray-500 max-w-sm mb-6" data-id="element-49">
              The social wallet for group spending. Pool money with friends,
              track expenses, and never chase payments again.
            </p>
            <div className="flex gap-4" data-id="element-50">
              <a href="https://www.linkedin.com/company/kitty-pot/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 hover:text-kitty-dark hover:bg-gray-100 transition-colors" data-id="element-51">
                <Linkedin className="w-5 h-5" data-id="element-52" />
              </a>
              <a href="https://www.facebook.com/people/Kittypotapp/100089385062763/?rdid=MRuINit14xpTUSpr&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1SAZAsYsVG%2F" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 hover:text-kitty-dark hover:bg-gray-100 transition-colors" data-id="element-53">
                <Facebook className="w-5 h-5" data-id="element-54" />
              </a>
              <a href="https://www.instagram.com/kittypotapp?igsh=Nm53NnEzemxqcjl5" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 hover:text-kitty-dark hover:bg-gray-100 transition-colors" data-id="element-55">
                <Instagram className="w-5 h-5" data-id="element-56" />
              </a>
            </div>
          </div>

          <div data-id="element-57">
            <h4 className="font-bold text-kitty-dark mb-4" data-id="element-58">Product</h4>
            <ul className="space-y-3" data-id="element-59">
              <li data-id="element-60">
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-500 hover:text-kitty-dark transition-colors text-left" data-id="element-61">
                  How it works
                </button>
              </li>
              <li data-id="element-62">
                <button onClick={() => scrollToSection('use-cases')} className="text-gray-500 hover:text-kitty-dark transition-colors text-left" data-id="element-63">
                  Use cases
                </button>
              </li>
              <li data-id="element-64">
                <button onClick={() => scrollToSection('pricing')} className="text-gray-500 hover:text-kitty-dark transition-colors text-left" data-id="element-65">
                  Pricing
                </button>
              </li>
              <li data-id="element-66">
                <button onClick={() => scrollToSection('waitlist')} className="text-gray-500 hover:text-kitty-dark transition-colors text-left" data-id="element-67">
                  Join waitlist
                </button>
              </li>
              <li data-id="element-68">
                <Link to="/faq" className="text-gray-500 hover:text-kitty-dark transition-colors" data-id="element-69">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-70">
            <h4 className="font-bold text-kitty-dark mb-4" data-id="element-71">Legal</h4>
            <ul className="space-y-3" data-id="element-72">
              <li data-id="element-73">
                <Link to="/privacy-policy" className="text-gray-500 hover:text-kitty-dark transition-colors" data-id="element-74">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/terms" className="text-gray-500 hover:text-kitty-dark transition-colors" data-id="element-76">
                  Terms and Conditions
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/cookie-policy" className="text-gray-500 hover:text-kitty-dark transition-colors" data-id="element-78">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-79">
                <Link to="/disclaimer" className="text-gray-500 hover:text-kitty-dark transition-colors" data-id="element-80">
                  Disclaimer
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/contact" className="text-gray-500 hover:text-kitty-dark transition-colors" data-id="element-82">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-83">
          <p className="text-gray-400 text-sm" data-id="element-84">
            © {new Date().getFullYear()} KittyPot Ltd. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm" data-id="element-85">Designed in the UK 🇬🇧</p>
        </div>
      </div>
    </footer>;
}